module.exports = __webpack_public_path__ + "static/media/bg.37646141.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg.png
// module id = 1434
// module chunks = 0